import React from "react";
import { Trash2 } from "lucide-react";
import { money } from "./utils";

// Compute visual style for a journal entry based on its kind & sign.
function entryStyle(entry) {
  const isProfit = entry.kind === "trade" && entry.amount >= 0;
  const isLoss = entry.kind === "trade" && entry.amount < 0;
  const isDeposit = entry.kind === "deposit";

  if (isProfit) {
    return { wrapper: "border-emerald-200 bg-emerald-50/50", value: "text-emerald-700", label: "PROFIT" };
  }
  if (isLoss) {
    return { wrapper: "border-rose-200 bg-rose-50/50", value: "text-rose-700", label: "LOSS" };
  }
  if (isDeposit) {
    return { wrapper: "border-[#00b4ff]/30 bg-[#00b4ff]/[0.04]", value: "text-[#00b4ff]", label: "DEPOSIT" };
  }
  return { wrapper: "border-slate-200 bg-slate-50", value: "text-slate-700", label: entry.kind.toUpperCase() };
}

export default function JournalEntryRow({ entry, onDelete }) {
  const style = entryStyle(entry);
  const displayValue = entry.kind === "trade" ? money(entry.amount) : `$${entry.amount.toFixed(2)}`;

  return (
    <div
      className={`rounded-xl border p-4 flex items-center justify-between gap-3 ${style.wrapper}`}
      data-testid={`journal-entry-${entry.id}`}
    >
      <div className="min-w-0 flex-1">
        <div className="flex items-center gap-2 flex-wrap">
          <span className="text-[10px] font-mono-plex tracking-widest uppercase text-slate-600">{style.label}</span>
          <span className={`font-mono-plex font-semibold ${style.value}`}>{displayValue}</span>
        </div>
        {entry.note && <div className="mt-1 text-sm text-slate-600 truncate">{entry.note}</div>}
      </div>
      <button
        data-testid={`journal-delete-${entry.id}`}
        onClick={() => onDelete(entry.id)}
        className="text-slate-400 hover:text-rose-600 p-1"
        style={{ transition: "color 0.2s ease" }}
        aria-label="Delete entry"
      >
        <Trash2 size={14} />
      </button>
    </div>
  );
}
